import React, { useEffect, useState } from "react";
import insicon from "../../Assets/InfoIcon.png";
import redicon from "../../Assets/redicon.png";
import defaultImage from "../../../src/Assets/fallbackimg_giftcard.png";
import getTranslationData from "../../TranslationUtility/TranslationUtility.js";
import { useSelector } from "react-redux";
import {
  getImageUrl,
  trackEvent,
  useClientConfigFlag,
} from "../Utility/Utility.js";
import ProductAttributes from "../ProductAttributes/ProductAttributes";
import ReedemType from "../Card/RedeemType.js";
import PurchaseLimitPill from "./PurchaseLimitPill.js";
import PdpTermsActions from "./PdpTermsActions";

const GiftCardDetailsSection = (productDetails) => {
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 768);
  const [stockOutDenominations, setStockOutDenominations] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const translation = getTranslationData();
  const toggleExpanded = () => {
    setExpanded(!expanded);
  };
  useEffect(() => {
    const handleResize = () => setIsMobileView(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    trackEvent("page_browse", {
      page_title: productDetails.productReducer?.name,
      page_url: window.location.href,
    });
  }, []);

  useEffect(() => {
    if (productDetails?.productReducer?.clientProductDenomination) {
      setStockOutDenominations(productDetails.productReducer.clientProductDenomination.every((item) => item.stockOut === true));
    }
  }, [productDetails]);

  const description = productDetails?.productReducer?.description || "";
  const clientConfigReducer = useSelector(
    (state) => state.clientConfigurationReducer?.clientConfigurationData?.[0]
  );
  const isDiscountShowLabel =
    clientConfigReducer?.clientConfig?.find(
      (item) => String(item?.configKey ?? "").trim().toLowerCase() === "isdiscountlabeldisplay"
    )?.configValue ?? clientConfigReducer?.isDiscountLabelDisplay;
  const isDiscountShowLabelConfig =
    isDiscountShowLabel === true ||
    isDiscountShowLabel === 1 ||
    ["1", "true", "active"].includes(String(isDiscountShowLabel ?? "").trim().toLowerCase());
  const isProductAttributeGridEnabled = useClientConfigFlag(
    "isProductAttributeGridDisplay"
  );
  const strippedDescription = description.replace(/<[^>]+>/g, "");
  const truncationLength = isMobileView ? 80 : 180;
  const isLongDescription = strippedDescription.length > truncationLength;
  const skuValidity =
    productDetails?.productReducer?.validity ??
    productDetails?.productReducer?.productReducerDisocount?.validity ??
    null;
  return (
    <section className="bg-white pb-0Mob mt-3 pdp-details-section">
      <div className="container big-rr mb-2">
        <div className="row justify-content-center p-2">
          <div className="col-lg-4 plusminus mb-2">
            <div className="img-cart text-center position-relative">

              <img
                className="w-100 h-gift gift_card_image_radius"
                style={{ width: "410px", height: "268px" }}
                src={getImageUrl(productDetails?.productReducer?.mobile) || defaultImage}
                alt={productDetails?.productReducer?.name || ""}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = defaultImage;
                }}
              />
              {stockOutDenominations && (
                <div className="stockout-image-container outoffstock_denominations">
                  <div className="stockout-image stockout-top-50">

                    <span className="stockout-text">
                      {translation?.stock_out}
                    </span>

                  </div>

                </div>
              )}
            </div>
          </div>
          <div className="col-lg-8 mt-2 pl-25 pdp-product-info">
            <div
              id="carouselBrandControls"
              className="carousel slide"
              data-bs-ride="false"
              data-bs-touch="false"
            >
              <div className="carousel-inner">
                <div className="carousel-item active">
                  <div className="mb-3">
                    <h4
                      className={`dis-mr-2 fnt-bold procardname ${
                        isProductAttributeGridEnabled ? "mb-0" : ""
                      }`}
                    >
                      {productDetails.productReducer?.name}
                    </h4>
                    <div className="row">
                      <div
                        className={
                          isProductAttributeGridEnabled ? "col-12" : "col-8"
                        }
                      >
                        <span className={` ${isDiscountShowLabelConfig ? "pro-discount" : "pro-discount d-none"}`}>
                          {productDetails?.productReducer?.customerDiscount !==
                            0 &&
                            `${translation.discount_flat} ${productDetails?.productReducer?.customerDiscount}%`}
                        </span>

                        {isProductAttributeGridEnabled ? (
                          <ProductAttributes
                            redeemableType={
                              productDetails?.productReducer?.redeemableType ||
                              ""
                            }
                            validity={skuValidity}
                          />
                        ) : (
                          <>
                            <ReedemType
                              status={
                                productDetails?.productReducer
                                  ?.redeemableType || ""
                              }
                            />
                            <ProductAttributes
                              validity={skuValidity}
                              include={["validity"]}
                            />
                          </>
                        )}
                      </div>
                      {!isProductAttributeGridEnabled && (
                        <div className="col-4 ">
                          <PurchaseLimitPill />
                        </div>
                      )}
                    </div>
                  </div>
                  <div>
                    <div className="fs-14 pt-md-0">
                      {expanded ? (
                        <div
                          className="pro-discrip description-html"
                          dangerouslySetInnerHTML={{
                            __html: description,
                          }}
                        ></div>
                      ) : (
                        // Show More sits inline, right after the truncated text.
                        <p className="pro-discrip pro-discrip--collapsed">
                          <span
                            className="pro-discrip-text"
                            dangerouslySetInnerHTML={{
                              __html: `${description.substring(
                                0,
                                truncationLength
                              )}${isLongDescription ? "..." : ""}`,
                            }}
                          ></span>
                          {isLongDescription && (
                            <>
                              {" "}
                              <span className="show-more" onClick={toggleExpanded}>
                                {translation?.showMore}
                              </span>
                            </>
                          )}
                        </p>
                      )}
                      {expanded && (
                        <span className="show-less" onClick={toggleExpanded}>
                          {translation?.showLess}
                        </span>
                      )}
                    </div>
                    <PdpTermsActions
                      productDetails={productDetails}
                      placement="below-description"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GiftCardDetailsSection;
